import { DwollaCustomerType } from '../common/enums/dwolla-customer-type';

export const isBillingAvailable = (): boolean => {
  const { data } = useAuth();
  const $auth = data.value;

  return !!$auth && $auth.accountAppType === 2 && $auth.type === DwollaCustomerType.Business;
};
